<div class="mobileFilterBar__cont">
  <div class="mobileFilterBar__cont__slide" [class.sticky]="isSticky">
    <ng-content select="[allBtn]"></ng-content>
    <div class="mobileFilterBar__selected-filters">
      <ng-content select="[selectedSlide]"></ng-content>
    </div>
    <ng-content select="[filterSlide]"></ng-content>
    <ng-content select="[moreBtn]"></ng-content>
  </div>
  <ng-content select="[barWidgets]"></ng-content>
</div>
